import CountUp from "react-countup";

function Percentile(props) {
    const { size, percentile, colour } = props;

    return (
        <div
            className={
                "h-full py-4 lg:py-0 lg:px-8 flex flex-col gap-2 items-center justify-center lg:justify-center lg:shadow-sm  " +
                ("text-" + colour + "-600") +
                " transition transition-color duration-4000 ease-in-out " +
                ("bg-" + colour + "-50") +
                (size === " large" ? " h-full w-full rounded-xl " : " w-full rounded-xl")
            }
        >
            <div>
                <span className={(size === "large" ? "lg:text-5xl text-4xl  " : "text-xl  ") + "font-medium"}>
                    <CountUp end={percentile} duration={4} />
                </span>
                <span className={"text-lg"}>%ile</span>
            </div>
            <span className="text-sm font-medium">{percentile >= 34 && percentile < 68 ? "Moderate" : "High"}</span>
        </div>
    );
}

export default Percentile;
